import useCurrentLocale from 'lib/hooks/useCurrentLocale'

import useApiSWR, { ApiSWRResponse } from './useApiSWR'

interface ViewWalkResponse {
  ActivityID: number
}

const useViewWalk = (
  walkSlug: string,
  enabled?: boolean
): ApiSWRResponse<ViewWalkResponse> => {
  const locale = useCurrentLocale()

  const params = {
    WalkID: walkSlug,
    LanguageCode: locale,
  }

  return useApiSWR<ViewWalkResponse>({
    method: 'POST',
    endpoint: '/api/Walk/ViewWalk',
    params,
    enabled,
    config: {
      revalidateOnFocus: false,
    },
  })
}

export default useViewWalk
